import { gql } from '@apollo/client'

import { USER_DETAILS_FRAGMENT } from '../fragments'

const UPDATE_USER_MUTATION = gql`
  mutation updateUser($id: ID!, $data: UserInput!) {
    updateUser(id: $id, data: $data) {
      ...UserDetailsFragment
    }
  }
  ${USER_DETAILS_FRAGMENT}
`

export default UPDATE_USER_MUTATION
